import React from "react";
import { Link } from "react-router-dom";

function SignupClosedPage() {
  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-brand centered">
          <div className="brand__title">Signups paused</div>
          <div className="brand__subtitle">
            We&apos;re not accepting new signups at this time, but check back soon.
          </div>
        </div>

        <div className="auth-actions">
          <Link className="button secondary full-width" to="/login">
            Return to login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SignupClosedPage;
